import { get, post, put, Delete } from "../axios";

// 盘厂列表-项目信息-列表
export const factoryManageProjectList = (params) =>
    get("/web/factory/manage/project/list", params);

// 盘厂列表-项目信息-新增
export const factoryManageProjectAdd = (params) =>
    post("/web/factory/manage/project/add", params);

// 盘厂列表-项目信息-编辑
export const factoryManageProjectUpdate = (params) =>
    put("/web/factory/manage/project/update", params);

// 盘厂列表-项目信息-删除
export const factoryManageProjectDelete = (id) =>
    Delete("/web/factory/manage/project/delete/" + id, "");
